<template>
  <div  class="flex block__slideout">
    <section>

      <!-- BLOCK PROFILE -->
      <b-row class="block__profile">
        <div class="mobile">
          <div class="link">
            <button class="bt btn-back" v-b-toggle.sidebar-profile>
                <font-awesome-icon :icon="['far', 'angle-left']"/>
            </button>
            <h3>{{general.profileTitle}}</h3>
          </div>
          <div class="sep"></div>
        </div>

        <div class="scrollable col">

          <b-list-group>
            <b-list-group-item>

              <a class="btn btn-profiler" v-b-toggle.sidebar-2>
                <div class="left">
                  <div class="btn-profile wrapper-icon">
                    <div class="back"></div>
                    <div class="initial">{{initial}}</div>
                  </div>
                  <div class="fullname">
                    {{fullName}}
                  </div>
                </div>

                <div class="arrow">
                    <font-awesome-icon :icon="['far', 'angle-right']"/>
                </div>
            </a> 

            </b-list-group-item>





            <b-list-group-item v-if="currentType == 'CONFIG_AGENT'">
              <a class="btn btn-collab" v-b-toggle.sidebar-3>
                <div class="left">
                  <div class="wrapper-icon">
                    <font-awesome-icon :icon="['far', 'users-medical']" />
                  </div>
                  {{general.profileTitleCollaborators}}
                </div>
                <div class="arrow">
                    <font-awesome-icon :icon="['far', 'angle-right']"/>
                </div>            
              </a> 
            </b-list-group-item>



            <b-list-group-item>
              <a class="btn btn-notification"  v-b-toggle.sidebar-4>
                <div class="left">
                  <div class="wrapper-icon">
                    <font-awesome-icon :icon="['far', 'bell']" />            
                  </div>
                  {{general.profileTitleNotifications}}
                </div>
                <div class="arrow">
                    <font-awesome-icon :icon="['far', 'angle-right']"/>
                </div>            
              </a> 
            </b-list-group-item>



            <b-list-group-item>
              <button class="btn btn-disconnect" v-on:click="disconnect()">
                <div class="wrapper-icon">
                  <font-awesome-icon :icon="['fas', 'sign-in']" />            
                </div>
                  {{general.profileTitleDisconnect}}
              </button>
            </b-list-group-item>
          </b-list-group>

        </div>

      </b-row>
      <!-- BLOCK PROFILE -->

      <!-- SIDEBAR -->
      <b-sidebar id="sidebar-2" right shadow :width="isMobile ?'100vw':'360px'">
        <ProfileInfo></ProfileInfo>
      </b-sidebar>
      <!-- SIDEBAR -->

      <!-- SIDEBAR -->
      <b-sidebar id="sidebar-3" right shadow :width="isMobile ?'100vw':'360px'">
        <ProfileCollab></ProfileCollab>
      </b-sidebar>
      <!-- SIDEBAR -->

      <!-- SIDEBAR -->
      <b-sidebar id="sidebar-4" right shadow :width="isMobile ?'100vw':'360px'">
        <ProfileNotifications></ProfileNotifications>
      </b-sidebar>
      <!-- SIDEBAR -->
    </section>

  </div>
</template>




<script>
import { mapGetters } from 'vuex'
import ProfileInfo from '../profile/ProfileInfo'
import ProfileCollab from '../profile/ProfileCollab'
import ProfileNotifications from '../profile/ProfileNotifications'
import ApiAuthenticationService from "@/services/ApiAuthenticationService";

export default {
    name:"profileHome",

    components:{
      ProfileInfo,
      ProfileCollab,
      ProfileNotifications           
    }, 

    computed: {
      ...mapGetters([
        'getGeneral',
        'getInitial',
        'getFullName',
          'getIsMobile'
      ])
    },

    data () {
      return {
        general:"",
        isLoading:true,
        initial:'',
        fullName:'',
        isMobile:false,
        currentType: ''
      }
    },
    
    // GET ALL THE INFORMATIONS / TRANSLATION
    mounted(){
      this.general = this.getGeneral;
      this.isMobile = this.getIsMobile;
    },

    // GET USER INITIAL AND FULLNAME
    async created (){
      this.initial = this.getInitial;
      this.fullName = this.getFullName;
      this.currentType = ApiAuthenticationService.getCurrentUser().type;
    },    

    methods : {
      // GO BACK
      goBack() {
        this.$store.dispatch('goBack')        
      },   
      // DISCONNECT
      disconnect: function (){
        this.$store.dispatch('disconnect');
      },
    },
  watch : {
    getIsMobile(){
      this.isMobile = this.getIsMobile;
    }
  }
};
</script>
